/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Login_LinkInputs */

const en_auth_signup_login_link = /** @type {(inputs: Auth_Signup_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in instead`)
};

const pl_auth_signup_login_link = /** @type {(inputs: Auth_Signup_Login_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się zamiast tego`)
};

/**
* | output |
* | --- |
* | "Sign in instead" |
*
* @param {Auth_Signup_Login_LinkInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_login_link = /** @type {((inputs?: Auth_Signup_Login_LinkInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Login_LinkInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_login_link(inputs)
	return en_auth_signup_login_link(inputs)
});